let translations = require('./Translations')

let computeCaption = translations.TranslationsUtils.methods.computeCaption
export const AccessionUtils = {
  methods: {
    getFieldDescription (fieldName) {
      if (this.$store.state.requirements[fieldName] !== undefined && (this.$store.state.requirements[fieldName]['details'] !== undefined || this.$store.state.requirements[fieldName]['details'] !== '')) {
        return computeCaption(this.$store.state.requirements[fieldName]['details'], this.$store.state.lang.value.toLowerCase())
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/AccessionDetailsProcessing.js